<template>
  <v-container fluid class="pt-0">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="5"
        class="pa-0 d-flex justify-center align-center flex-column"
        style="background-color: #081a81; height: 80vh"
      >
        <v-spacer></v-spacer>
        <h3 class="white--text mb-0" style="font-size: 1.2rem">
          <span>Maestría</span>
          en
        </h3>
        <h1 class="white--text text-center" style="font-size: 3rem">
          EDUCACIÓN
        </h1>
        <br />
        <v-spacer></v-spacer>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="7"
        class="pa-0"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <v-img :src="renderMedia(picture)" height="80vh" width="100%"></v-img>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="7" class="pa-0" v-else>
        <v-img :src="renderMedia(picture2)" height="80vh" width="100%"></v-img>
      </v-col>
    </v-row>
    <SectionDivider />
    <v-row class="py-5 mb-8">
      <v-col cols="12">
        <h1 class="mb-5 mx-3 mx-sm-3 mx-md-5 mx-lg-8 primary--text">
          Al egresar podrás desempeñarte como:
        </h1>
        <ul
          :class="$vuetify.breakpoint.mdAndUp ? 'mt-5 mr-5' : 'mt-5 px-2'"
          style="list-style-type: none"
        >
          <li
            v-for="(item, index) in egreso_list"
            :key="index"
            class="py-2 font-weight-regular"
            ALIGN="justify"
            :class="[$vuetify.breakpoint.xl ? 'title' : '']"
          >
            <span>
              <i ALIGN="justify" class="mdi mdi-chevron-right"></i>
              <strong>{{ item.title }}:</strong> {{ item.text }}
            </span>
          </li>
        </ul>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 5 : 12" class="pa-0">
        <v-img
          style="place-self: center"
          src="/maestria/Pie.png"
          height="110vh"
          width="60%"
        ></v-img>
      </v-col>
      <v-col
        :cols="$vuetify.breakpoint.mdAndUp ? 7 : 12"
        :class="
          $vuetify.breakpoint.mdAndUp
            ? 'px-6 py-6 d-flex justify-center flex-column dark'
            : 'px-6 py-6 d-flex justify-center flex-column dark  mt-5'
        "
        :style="
          $vuetify.breakpoint.mdAndUp
            ? 'background-color: #1B44D6;  height: 110vh;'
            : 'background-color: #1B44D6;  height: 170vh;'
        "
      >
        <br />
        <h2
          class="text-justify white--text mb-5"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          Atributos de la maestría:
        </h2>
        <h3 class="white--text mb-4">
          En esta Maestría tendrás el conocimiento para realizar:
        </h3>
        <ul
          class="white--text"
          v-for="(item, index) in requirements"
          :key="index"
        >
          <li>
            <h4 class="white--text font-weight-light">{{ item.text }}</h4>
          </li>
        </ul>
        <br />
        <br />
        <h2
          class="text-justify white--text mb-5"
          style="color: rgba(255, 255, 255, 0.7) !important"
        >
          Graduate en 2 años
        </h2>
        <h4 class="white--text font-weight-regular text-justify mb-4">
          El modelo de enseñanza de nuestro sistema de posgrado está diseñado
          para promover dicho aprendizaje basado principalmente en nuestras
          necesidades como país y mediante la utilización de estrategias
          significativas. En Vizcaya en Línea tienes al poder de continuar con
          la formación de tu futuro profesional al estudiar nuestro nuevo
          posgrado.
        </h4>
      </v-col>
    </v-row>

    <!-- Sección de semestres -->
    <v-container>
      <h1 class="mt-10 mb-6">Plan de estudios</h1>
      <v-row>
        <v-col
          class="mt-5"
          cols="12"
          lg="6"
          order="1"
          v-for="(item, index) in semesters"
          :key="index"
        >
          <h2 style="color: #3f538a" class="mb-3">{{ item.name }}</h2>
          <ul v-for="(obj, j) in item.options" :key="j">
            <li v-if="obj.bold != 1">
              <h3 class="font-weight-regular">{{ obj.text }}</h3>
            </li>
            <li v-else>
              <h3>{{ obj.text }}</h3>
            </li>
          </ul>
        </v-col>
      </v-row>

      <hr class="mt-10" style="height: 3px; background-color: black" />

      <v-col cols="12" class="mt-2">
        <h3 class="text-center font-weight-regular">
          Las materias en negritas son materias denominadas EJE, las cuales
          tienen una duración mayor a las demás.
        </h3>
      </v-col>
    </v-container>
  </v-container>
</template>
<style scoped>
.ligthBlue {
  background-color: #84a4d1;
}
.ligthBlueText {
  color: #84a4d1;
}
.ext-container {
  background-image: url("/images/imagenes/campo-accion.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 5;
}
.test {
  border-width: 1px !important;
  border-color: white !important;
  width: 100%;
}
.containerMovil {
  background-color: #4777bb;
  height: 140vh;
}
.bg-image {
  background-position: center;
  background-size: cover;
  height: 30vh;
  position: relative;
}
.bg-image::after {
  background-color: #1b44d6;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0.5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}
</style>
<script>
import _ from "lodash";
import SectionDivider from "../components/SectionDivider.vue";
import PlanForRedesign from "../components/PlanForRedesign.vue";

export default {
  components: {
    SectionDivider,
    PlanForRedesign,
  },
  data() {
    return {
      picture2: "/maestria/iphone.png",
      picture: "/maestria/foto.jpg",
      egreso_list: [
        {
          title: "Evaluador educativo",
          text: "Recogerás información y tomarás decisiones sobre diversas situaciones que requieran cambios o mejoras en la oferta educativa, administración, y procesos de enseñanza-aprendizaje de las instituciones.",
        },
        {
          title: "Investigador educativo",
          text: "Realiza investigaciones para identificar fenómenos educativos que puedan mejorarse y atenderse, delimitando tu objeto de estudio el cual investigarás, realizando un planteamiento e identificando las características de dicha investigación, suproceso, limitaciones y finalidad de la misma.",
        },
        {
          title: "Administrador y gestor educativo",
          text: "Planearás la mejora y transformación de los procesos educativos, utilizando métodos y técnicas de planeación y evaluación estratégica en instituciones, organizaciones e instancias del sistema educativo. Además colaborar con la comunidad escolar, padres de familia, autoridades y docentes en la toma de decisiones y en el desarrollo de alternativas de solución de problemáticas.",
        },
        {
          title: "Docente",
          text: "Compartirás conocimientos al alumnado (con necesidades, edades y capacidades diversas), empleando técnicas y métodos de enseñanza-aprendizaje, por los medios indicados (aula, plataforma u otras instalaciones especiales), ya sea presencial, semi presencial, o a distancia.",
        },
        {
          title: "Diseñador curricular",
          text: "Planearás la estructura curricular, en donde diseñarás los planes y programas de estudio de las áreas disciplinares, además de diseñar los proyectos educativos, dirigidos a instituciones educativas públicas y particulares.",
        },
      ],
      requirements: [
        { text: "Teorías educativas" },
        { text: "Aportaciones de ciencias de la educación" },
        { text: "Procesos de diseño curricular" },
        { text: "Procesos de diseño técnico pedagógico" },
        { text: "Procesos de evaluación" },
        { text: "Procesos de calidad en la educación" },
        { text: "Metodologías de la investigación educativa" },
        { text: "Procesos de administración de instituciones educativas" },
        { text: "Retos y porvenires de la educación en México" },
        { text: "Uso y aplicación de la tecnología educativa" },
        { text: "Uso y aplicación de estrategias docentes" },
        {
          text: "La implicación de políticas públicas con políticas educativas",
        },
      ],
      semesters: [
        {
          name: "Primer Semestre",
          options: [
            { text: "Paradigmas de la Investigación", bold: "1" },
            { text: "Filosofía Contempóranea y Educación", bold: "0" },
            { text: "Legislación y Políticas Educativas", bold: "0" },
            {
              text: "Modelos de Aprendizaje y Teorías Educativas Contemporáneas",
              bold: "0",
            },
          ],
        },
        {
          name: "Segundo Semestre",
          options: [
            { text: "Metodología de la Investigación Educativa", bold: "1" },
            { text: "Psicología Educativa", bold: "0" },
            { text: "Problemas del desarrollo del Sistema", bold: "0" },
            { text: "Comunicación y Tecnología Educativa", bold: "0" },
          ],
        },
        {
          name: "Tercer Semestre",
          options: [
            { text: "Desarrollo de Proyectos de Investigación", bold: "1" },
            { text: "Diseño Técnico Pedagógico", bold: "0" },
            { text: "Administración de Instituciones Educativas", bold: "0" },
            { text: "Desarrollo Curricular y Proceso Educativo", bold: "0" },
          ],
        },
        {
          name: "Cuarto Semestre",
          options: [
            { text: "Seminario de Tesis", bold: "1" },
            { text: "Sistemas de Evaluación", bold: "0" },
            { text: "Calidad Total en Educación", bold: "0" },
            { text: "Educación Comparada", bold: "0" },
            { text: "Taller de Docencia Académica y Empresarial", bold: "1" },
          ],
        },
      ],
    };
  },
  methods: {
    renderMedia(image) {
      return image;
    },
  },
  computed: {
    bgPrincipal() {
      return {
        "background-image": "url('" + this.picture + "')",
      };
    },
  },
};
</script>
